import React, { useEffect, useState } from 'react';
import { AuthLink as Link } from '../auth/AuthContext';
import { MailCheck } from 'lucide-react';
import api from '../api';
import AuthCard from '../components/AuthCard';
import Spinner from '../components/Spinner';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);

    // Куку с CSRF-токеном выдаёт приложение, а страницу отдаёт nginx: до первого обращения
    // к API её нет, и отправка формы отвергалась бы как запрос без токена.
    useEffect(() => { api.get('/api/auth/csrf').catch(() => {}); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (sending) return;

        setSending(true);
        setError(null);
        try {
            await api.post('/api/auth/password/forgot', { email });
            setSent(true);
        } catch (err) {
            setError(err.response?.status === 503
                ? 'Отправка почты не настроена. Обратитесь к администратору.'
                : 'Не удалось отправить письмо. Попробуйте позже.');
        } finally {
            setSending(false);
        }
    };

    if (sent) {
        return (
            <AuthCard title="Проверьте почту" backTo="/login" backLabel="К входу">
                <MailCheck size={44} className="text-blue-600 mx-auto mb-4" />
                <p className="text-gray-600 text-sm leading-relaxed">
                    Если адрес <span className="font-medium text-gray-900">{email}</span> зарегистрирован,
                    на него отправлена ссылка для смены пароля. Ссылка действует один час.
                </p>
                <p className="text-gray-500 text-[13px] mt-4">
                    Письмо не пришло? Проверьте папку со спамом или попробуйте ещё раз через минуту.
                </p>
            </AuthCard>
        );
    }

    return (
        <AuthCard
            title="Восстановление пароля"
            backTo="/login"
            backLabel="К входу"
            footer={<>Вспомнили пароль? <Link to="/login" className="text-blue-600 hover:underline font-medium">Войти</Link></>}
        >
            <p className="text-gray-600 text-sm mb-5 leading-relaxed">
                Укажите адрес почты, привязанный к аккаунту. Мы отправим на него ссылку для смены пароля.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input
                    className="p-3 border border-gray-300 rounded-lg text-base transition-colors focus:border-blue-500 focus:outline-none disabled:bg-gray-50"
                    type="email"
                    placeholder="Email"
                    value={email}
                    disabled={sending}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoFocus
                />
                {error && <div className="text-red-600 bg-red-50 p-3 rounded-md text-sm">{error}</div>}
                <button
                    type="submit"
                    disabled={sending}
                    className="bg-blue-600 text-white p-3 border-none rounded-lg text-base font-semibold transition-colors shadow-sm flex items-center justify-center gap-2 enabled:cursor-pointer enabled:hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-default"
                >
                    {sending && <Spinner size={18} />}
                    {sending ? 'Отправляем…' : 'Отправить ссылку'}
                </button>
            </form>
        </AuthCard>
    );
};

export default ForgotPasswordPage;
